import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {
  username: string
  password: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const LOGIN_MUTATION = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      user {
        suchname
        username
        passwort
        email
      }
    }
  }
`

const withLoginMutation = graphql<InputProps, Response, Variables, ChildProps>(LOGIN_MUTATION, {
  name: 'loginMutation',
})

export default withLoginMutation
